import { OLD_MATERIAL_THRESHOLD } from "../constants/teaching_materials";

export const isOldMaterial = (mitsuwaId: string | undefined): boolean => {
  if (!mitsuwaId) return false;
  const num = parseInt(mitsuwaId.replace(/^[A-Za-z]+/, ""), 10);
  return !Number.isNaN(num) && num <= OLD_MATERIAL_THRESHOLD;
};
